/**
 * ReadOnlyContext — signals components to hide edit controls.
 *
 * Used by the published project viewer to prevent edits for non-owners,
 * while allowing owners to retain full interactivity.
 */

import { createContext, useContext } from 'react'

export const ReadOnlyContext = createContext<boolean>(false)

export function useReadOnly(): boolean {
  return useContext(ReadOnlyContext)
}
